
import React from 'react';
import { SearchX, FileSpreadsheet } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface EmptyStateProps {
  searchQuery?: string;
  onClearSearch?: () => void;
  isSearching: boolean;
}

const EmptyState: React.FC<EmptyStateProps> = ({ searchQuery, onClearSearch, isSearching }) => {
  return (
    <div className="flex flex-col items-center justify-center p-8 bg-muted/30 rounded-lg border border-dashed h-64">
      {isSearching ? (
        <>
          <SearchX className="h-16 w-16 text-muted-foreground mb-4" />
          <h3 className="text-xl font-medium mb-2">No results found</h3>
          <p className="text-muted-foreground text-center mb-4">
            No leads found for "{searchQuery}". Try a different search term.
          </p>
          {onClearSearch && (
            <Button onClick={onClearSearch} variant="outline">
              Clear Search
            </Button>
          )}
        </>
      ) : (
        <>
          <FileSpreadsheet className="h-16 w-16 text-muted-foreground mb-4" />
          <h3 className="text-xl font-medium mb-2">No leads yet</h3>
          <p className="text-muted-foreground text-center mb-4">
            Search for businesses to add leads to your list.
          </p>
        </>
      )}
    </div>
  );
};

export default EmptyState;
